import React, {Component} from 'react';
import CheckBox from './CheckBox';
import SurveySlider from './SurveySlider';
import RadioGroup from './RadioGroup';
import CheckBoxMulti from './CheckBoxMulti';
import CustomCheckBox from './CustomCheckBox';

export default class SurveyQuestion extends Component {
    constructor (props) {
        super(props)
        this.state = {}
    }

    formControl = (data, prepop) => {

        let questionGroups = []

        data.questions.forEach((question, i) => {
            questionGroups.push({ 'questionGroup': question.questionGroupID,
                'questionType': question.questionType
             })
        })

        if (data.questions.length > 0 && data.questions[0].hasOwnProperty('questionType')) {
          const questionType = parseInt(data.questions[0].questionType)
          
          switch (questionType) {
            case 1:
              return (<CheckBox data={data} questionNumber={this.props.questionNumber} manageFormData={this.props.manageFormData} prepop={prepop} />)
            case 2:
              return (<CheckBoxMulti data={data} questionNumber={this.props.questionNumber} manageFormData={this.props.manageFormData} prepop={prepop} />)
            case 3:
              return (<SurveySlider data={data} questionNumber={this.props.questionNumber} manageFormData={this.props.manageFormData} prepop={prepop} />)
            case 4:
              return (<SurveySlider data={data} questionNumber={this.props.questionNumber} manageFormData={this.props.manageFormData} prepop={prepop} />)
            case 5:
              return (<RadioGroup data={data} questionNumber={this.props.questionNumber} manageFormData={this.props.manageFormData} prepop={prepop} />)
            case 6:
              return (<CustomCheckBox data={data} questionNumber={this.props.questionNumber} manageFormData={this.props.manageFormData} prepop={prepop} />)
            default:
          }
        }

        return (<p>An error has occured</p>)
    }

    render() {
        var active = this.props.active ? 'question active' : 'question';
        return (
            <div
              key={'question' + this.props.questionNumber}
              id={'question' + this.props.questionNumber}
            >
                <div className={active}>
                    <span className='question-number'>{this.props.questionNumber + 1}</span>
                    { this.formControl(this.props.data, this.props.prepop)}
                </div>
            </div>
        )
    }
}